import { Component, Input, OnInit } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-field-validator',
  templateUrl: './field-validator.component.html',
  styleUrls: ['./field-validator.component.scss'],
  standalone: false,
})
export class FieldValidatorComponent implements OnInit {
  @Input() field: any;
  @Input() formErrors: ValidationErrors | undefined | null;
  @Input() fieldId: string = ''; // ID del campo per aria-describedby

  constructor() {}

  ngOnInit(): void {
    console.log(this.field);
  }
}
